import { SxProps } from '@mui/material';

export const QuestionFormStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '32px',
    maxWidth: '900px',
    margin: '40px auto',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.08)',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '0',
    maxWidth: '900px',
    margin: '0 auto',
  },
  sectionCard: {
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
    border: '1px solid #f0f0f0',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
    },
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#2c3e50',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&::before': {
      content: '""',
      width: '4px',
      height: '20px',
      backgroundColor: '#3498db',
      borderRadius: '2px',
    },
  },
  autocompleteField: {
    flex: 1,
    minWidth: '200px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fafafa',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 2px rgba(52, 152, 219, 0.2)',
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: '500',
      color: '#5a6c7d',
    },
  },
  optionPaper: {
    padding: '16px',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
  optionTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#fafafa',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 2px rgba(52, 152, 219, 0.2)',
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: '500',
      color: '#5a6c7d',
    },
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '24px 0',
    marginTop: '16px',
  },
  submitButton: {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '16px 48px',
    borderRadius: '12px',
    fontSize: '1.1rem',
    fontWeight: '600',
    textTransform: 'none',
    minWidth: '200px',
    transition: 'all 0.3s ease',
    boxShadow: '0px 4px 16px rgba(52, 152, 219, 0.3)',
    '&:hover': {
      backgroundColor: '#2980b9',
      transform: 'translateY(-2px)',
      boxShadow: '0px 6px 20px rgba(52, 152, 219, 0.4)',
    },
    '&:active': {
      transform: 'translateY(0px)',
    },
  },
  header: {
    fontSize: '2rem',
    margin: '0 0 32px 0',
    fontWeight: '700',
    textAlign: 'center',
    color: '#2c3e50',
    background: 'linear-gradient(135deg, #3498db, #2980b9)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
  },
  selectField: {
    width: '100%',
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    '& .MuiSelect-select': {
      padding: '12px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  textArea: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #dcdde1',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    transition: 'border-color 0.3s, box-shadow 0.3s',
    '&:focus': {
      outline: 'none',
      borderColor: '#3498db',
      boxShadow: '0 0 8px rgba(52, 152, 219, 0.4)',
    },
  },
  textField: {
    width: '100%',
    margin: '8px 0px',
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#fafafa',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: '#3498db',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3498db',
      },
    },
  },
  button: {
    alignSelf: 'center',
    backgroundColor: '#3498db',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    textTransform: 'none',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    '&:hover': {
      backgroundColor: '#2980b9',
      boxShadow: '0px 4px 12px rgba(52, 152, 219, 0.5)',
    },
  },
  label: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#2c3e50',
    marginBottom: '8px',
  },
  radioGroup: {
    marginLeft: '10px',
  },
} satisfies Record<string, SxProps>;
